import ModelMappingOrigin from "~/models/mapping/modelMappingOrigin";
import PaymentStep from "../../../formability/form_builder/models/workflow/paymentStep";
import ModelMappingValueOrigin from "~/models/mapping/modelMappingValueOrigin";
import {IDefaultVOption} from "~/interfaces/vSelectInterfaces";
import {PaymentProperty, PaymentPropertyType} from "~/enums/paymentPropertyType";
import OriginWrapperPaymentStepLineItem from "~/models/mapping/originWrapperPaymentStepLineItem";
import {RegexHelper} from "~/helpers/regexHelper";
import {PaymentLineItemInformationType} from "../../../formability/mappingBuilder/enums/payment-information-type";
import ModelMappingValueOriginPaymentStepLineItem from "~/models/mapping/modelMappingValueOriginPaymentStepLineItem";

interface IValue {
  label_title: string
  client_id: string
  labelSuffix: string
  section?: string
}

// When Form Payment Step is the origin
export default class ModelMappingOriginPaymentStepLineItem extends ModelMappingOrigin<PaymentStep> {
  isSingle = false
  static ID_FORMAT = new RegExp(`^${OriginWrapperPaymentStepLineItem.addSuffix('(' + RegexHelper.strings.clientId + ')')}$`)

  get stepClientId(): string {
    return this.id.match(ModelMappingOriginPaymentStepLineItem.ID_FORMAT)[1]
  }

  get origin(): PaymentStep {
    return PaymentStep.repo.find(this.stepClientId);
  }

  get identifier(): string {
    return OriginWrapperPaymentStepLineItem.addSuffix(this.origin?.client_id)
  }

  get title(): string {
    return OriginWrapperPaymentStepLineItem.displayLabel(this.origin?.titleOrDefault)
  }

  get values(): IValue[] {
    const values: IValue[] = []
    if (!this.origin) return values
    const buildValue = (type: PaymentLineItemInformationType) => {
      return {
        client_id: ModelMappingValueOriginPaymentStepLineItem.buildId(this.origin, type),
        label_title: ModelMappingValueOriginPaymentStepLineItem.buildLabel(this.origin, type),
        labelSuffix: `(${ModelMappingValueOriginPaymentStepLineItem.buildLabelSuffix(this.origin, type)})`,
      }
    }

    values.push(
      buildValue(PaymentLineItemInformationType.Name),
      buildValue(PaymentLineItemInformationType.Type),
      buildValue(PaymentLineItemInformationType.SKU),
      buildValue(PaymentLineItemInformationType.Amount),
      buildValue(PaymentLineItemInformationType.Description),
      buildValue(PaymentLineItemInformationType.DateOfPayment),
    )

    return values
  }

  searchValues(query?: string, options: { filters?: ((value: string) => boolean)[], showUnmappedOnly?: boolean } = {}): Partial<this['values']> {
    const filters = [
      value => value.label_title?.toLowerCase().trim().includes(query?.toLowerCase().trim())
    ]
    if (options.showUnmappedOnly) {
      filters.unshift(value => {
        return !this.modelMapping.isMapped(value.client_id)
      })
    }
    return this.values.filter(value => filters.every(f => f(value)))
  }

  valueOptions(source: ModelMappingValueOrigin = null): IDefaultVOption[] {
    const values: IDefaultVOption[] = []
    values.push({
      label: 'Amount',
      value: PaymentProperty.Amount,
      labelSuffix: PaymentPropertyType[PaymentProperty.Amount]
    })
    return values
  }

  /**
   * PaymentStep model mapping origin has not uploader value options
   */
  uploaderValueOptions: IDefaultVOption[] = []

  /**
   * Take results from the values search and format them as a-select options
   * @param value
   */
  mapValueToOption(value: IValue): IDefaultVOption {
    return {
      label: value.label_title,
      value: value.client_id,
      labelSuffix: value.labelSuffix,
      section: value.section,
    }
  }
}